export default <T>(condition: boolean, ...elements: (T | (() => T))[]): T[] =>
    condition ? elements.map(e => (typeof e === 'function' ? (e as Function)() : e)) : [];
